import { render, staticRenderFns } from "./PaymentComingSoonModal.vue?vue&type=template&id=d6c12216&scoped=true"
import script from "./PaymentComingSoonModal.vue?vue&type=script&lang=js"
export * from "./PaymentComingSoonModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentComingSoonModal.vue?vue&type=style&index=0&id=d6c12216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c12216",
  null
  
)

export default component.exports